module.exports = {"save":{"labels":{"title":"SAUVEGARDE","save":"Sauvegarde","saveBackToList":"et retour à la liste","saveBackToAdd":"et ajouter un nouveau","preparePreview":"Préparer la prévisualisation","warning":"La page n'est pas sauvegardée, gardez cette fenêtre ouverte","preview":"Liens de prévisualisation"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/Save/admin-fr.json
// module id = 5p9G
// module chunks = 18